import CaseCreationConfirmPayment from '@brands/Dashboard/PatientForms/CaseCreation/PaymentInformation/ConfirmPayment';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import ConfirmPayment from './ConfirmPayment';

const ConfirmPaymentRoute: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (!userInfo) {
    return null;
  }
  if (userInfo.role.name === UserRoleName.Patient) {
    return <ConfirmPayment />;
  }
  if (!isUnifiedStaffCaseIntakeRole(userInfo.role.name)) {
    return <ConfirmPayment />;
  }
  return <CaseCreationConfirmPayment />;
};

export default ConfirmPaymentRoute;
